import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
    const [isActive, setIsActive] = useState(false);

    const toggleSidebar = () => setIsActive(!isActive);
    const closeSidebar = () => setIsActive(false);

    return (
        <>
            {/* Overlay للموبايل */}
            {isActive && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
                    style={{ zIndex: 998 }}
                    onClick={closeSidebar}
                ></div>
            )}

            {/* Sidebar */}
            <div className={`sidebar ${isActive ? "active" : ""}`}>
                <h4 className="p-3 border-bottom d-flex justify-content-between align-items-center flex-row-reverse">
                    🏋️‍♂️ جيم بورد
                    <button
                        className="btn btn-dark d-md-none"
                        onClick={toggleSidebar}
                        style={{fontSize: "1.2rem"}}
                    >
                        ✖
                    </button>
                </h4>


                <ul className="nav flex-column mt-3">
                    <li className="nav-item mb-2">
                        <Link to="/dashboard" className="nav-link" onClick={closeSidebar}>
                            الصفحة الرئيسية <i className="bi bi-house"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/home" className="nav-link" onClick={closeSidebar}>
                            صفحة المستخدم <i className="bi bi-person"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/members" className="nav-link" onClick={closeSidebar}>
                            الأعضاء <i className="bi bi-people"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/muscle" className="nav-link" onClick={closeSidebar}>
                            التمارين <i className="bi bi-people"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/muscle_exercises" className="nav-link" onClick={closeSidebar}>
                            التمارين الفرعية <i className="bi bi-people"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/programs" className="nav-link" onClick={closeSidebar}>
                            البرامج <i className="bi bi-people"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/members-programs" className="nav-link" onClick={closeSidebar}>
                            تعين البرامج للأعضاء <i className="bi bi-people"></i>
                        </Link>
                    </li>

                    <li className="nav-item mb-2">
                        <Link to="/admin-chat" className="nav-link" onClick={closeSidebar}>
                            رسائل المشتركين<i className="bi bi-people"></i>
                        </Link>
                    </li>


                    <li className="nav-item mb-2">
                        <Link to="/logout" className="nav-link" onClick={closeSidebar}>
                            تسجيل خروج <i className="bi bi-box-arrow-right"></i>
                        </Link>
                    </li>

                </ul>
            </div>

            {/* زر Toggle للموبايل */}
            <button
                className="btn btn-dark d-md-none position-fixed m-2"
                style={{zIndex: 1000, left: "10px"}}
                onClick={toggleSidebar}
            >
            <i className="bi bi-list"></i>
            </button>
        </>
    );
}
